import React from 'react';
import { ENUM_ANCHORS } from '../../../../enums/enums';
import { List, ListItemButton, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../../../../components/material-ui/ShowContainer';

export default function AnchorsLink({
  title = "You can add anchors to the site's referral link that control the opening of modal windows",
  exampleLink,
  onAnchorClick
}) {
  const { t } = useTranslation();

  const anchors = [
    { name: ENUM_ANCHORS.signup, description: 'anchor opens the registration window' },
    {
      name: ENUM_ANCHORS.signupOn,
      description: 'anchor opens registration window without possibility to close'
    },
    {
      name: ENUM_ANCHORS.signupDepositOn,
      description:
        'the anchor opens a registration window without the ability to close it, and after registration a modal deposit window without the ability to close it'
    },
    {
      name: ENUM_ANCHORS.fortune,
      description: "anchor opens the 'Wheel of Fortune' window and the registration modal window"
    },
    {
      name: ENUM_ANCHORS.fortuneOn,
      description:
        "anchor opens the 'Wheel of Fortune' window and the registration modal window without the ability to close"
    },
    {
      name: ENUM_ANCHORS.fortuneOn,
      description:
        "anchor opens the 'Wheel of Fortune' window and the registration modal window without the ability to close"
    },
    {
      name: `${ENUM_ANCHORS.deposit}?currency=RUB&amount=100`,
      description: 'The anchor will open a balance replenishment window.'
    },
    {
      name: ENUM_ANCHORS.promocode,
      description: 'Clicking the link will open the promo code activation window.'
    }
  ];

  return (
    <List>
      <Typography variant="h6" mb={1} mt={2} color="textPrimary">
        {t(title)}
      </Typography>

      {anchors.map((el, indx) => (
        <ListItemButton key={indx} style={{ padding: 1 }} onClick={() => onAnchorClick(el.name)}>
          <ListItemText
            primary={
              <Typography color="primary" fontWeight={600}>
                {t(el.name)}
              </Typography>
            }
            secondary={t(el.description)}
          />
        </ListItemButton>
      ))}

      <Typography variant="body1" mt={2} color="textSecondary">
        {t('If the user is authorized, then the bindings are ignored, except for', {
          except: ENUM_ANCHORS.deposit
        })}
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {t(
          'If the user was previously logged in to the current browser, then the ability to close the modal window will always be present'
        )}
      </Typography>
      <ShowContainer condition={exampleLink}>
        <Typography variant="inherit" mt={1} color="textSecondary">
          <b>{t('Example')}</b>: {exampleLink}
        </Typography>
      </ShowContainer>
    </List>
  );
}
